import { createSelector } from "reselect";

import { AppState } from "../rootReducer";

//Override List
const getOverrideListPending = (state: AppState) => state.overrides.pending;
const getOverrideList = (state: AppState) => state.overrides.overrides;
const getOverrideListError = (state: AppState) => state.overrides.error;

export const getOverrideListSelector = createSelector(getOverrideList, (overrides) => overrides);
export const getOverrideListPendingSelector = createSelector(getOverrideListPending,(pending) => pending);
export const getOverrideListErrorSelector = createSelector(getOverrideListError, (error) => error);

//Override Post
const postOverridePending = (state: AppState) => state.postOverride.pending;
const postOverride = (state: AppState) => state.postOverride.override;
const postOverrideError = (state: AppState) => state.postOverride.error;

export const postOverrideSelector = createSelector(postOverride, (overrides) => overrides);
export const postOverridePendingSelector = createSelector(postOverridePending,(pending) => pending);
export const postOverrideErrorSelector = createSelector(postOverrideError, (error) => error);

//Override Put
const putOverridePending = (state: AppState) => state.putOverride.pending;
const putOverride = (state: AppState) => state.putOverride.override;
const putOverrideError = (state: AppState) => state.putOverride.error;

export const putOverrideSelector = createSelector(putOverride, (overrides) => overrides);
export const putOverridePendingSelector = createSelector(putOverridePending,(pending) => pending);
export const putOverrideErrorSelector = createSelector(putOverrideError, (error) => error);

//Override Get
const getOverridePending = (state: AppState) => state.overrideDetails.pending;
const getOverrideOverride = (state: AppState) => state.overrideDetails.override;
const getOverrideError = (state: AppState) => state.overrideDetails.error;

export const getOverrideSelector = createSelector(getOverrideOverride, (overrides) => overrides);
export const getOverridePendingSelector = createSelector(getOverridePending,(pending) => pending);
export const getOverrideErrorSelector = createSelector(getOverrideError, (error) => error);

//Override Delete
const deleteOverridePending = (state: AppState) => state.deleteOverride.pending;
const deleteOverrideOverride = (state: AppState) => state.deleteOverride.success;
const deleteOverrideError = (state: AppState) => state.deleteOverride.error;

export const deleteOverrideSelector = createSelector(deleteOverrideOverride, (overrides) => overrides);
export const deleteOverridePendingSelector = createSelector(deleteOverridePending,(pending) => pending);
export const deleteOverrideErrorSelector = createSelector(deleteOverrideError, (error) => error);